import React from 'react'
import './__styles__/index.css'
import { Logo, MenuItem as _MenuItem } from './__styles__'
import Icon from '../__assets__/compass-drafting-solid.svg'
import { COLOUR } from '../__constants__'


export default function MenuItem({ title = '', isSelected = false, onClick = () => { } }) {

    const fontColor = isSelected ? null : COLOUR.SELECTED_MENU_ITEM_FONT_COLOUR;
    return (

        <_MenuItem className='menu-item'
            style={{
                color: fontColor,
                backgroundColor: isSelected ? COLOUR.SELECTED_MENU_ITEM : null
            }}
            onClick={onClick}>
            <div style={{ color: fontColor }}>
                <Logo src={Icon} style={{ width: 16, height: 16 }} />
            </div>
            <div>{title}</div>
        </_MenuItem>
    )
}
